import { IPagePath } from '@/models/linkingTool.model';

export enum ModalViews {
  CREATE = 'create',
  EDIT = 'edit',
  DELETE = 'delete',
  IMPORT = 'import',
}

export enum LinkingFormFields {
  PAGE_PATH = 'pagePath',
  LINKS = 'links',
  TITLE = 'title',
  PATH = 'path',
}

export enum InterLinksImportFormFields {
  FILE = 'file',
}

export type TInterLinksImportFormValues = {
  [InterLinksImportFormFields.FILE]: File;
};

export type TCreateLinkingTemplateFormValues = {
  [LinkingFormFields.PAGE_PATH]: string;
  [LinkingFormFields.LINKS]: IPagePath[];
  [LinkingFormFields.TITLE]: string;
  [LinkingFormFields.PATH]: string;
};

export type TUpdateLinkingTemplateFormValues = {
  [LinkingFormFields.PAGE_PATH]: string;
  [LinkingFormFields.LINKS]?: IPagePath[];
  [LinkingFormFields.TITLE]?: string;
  [LinkingFormFields.PATH]?: string;
};
